export default __webpack_public_path__ + "static/argo-ecfabae4807032fb1caa0a3ac10c7298.png";